export default __webpack_public_path__ + "f5c7b5cd7fd84bf539a5a6772a3b607d.png";